import { render, staticRenderFns } from "./popup-chosen-new.vue?vue&type=template&id=1d792a36&scoped=true"
import script from "./popup-chosen-new.vue?vue&type=script&lang=ts"
export * from "./popup-chosen-new.vue?vue&type=script&lang=ts"
import style0 from "./popup-chosen-new.vue?vue&type=style&index=0&id=1d792a36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../.eden-mono/temp/node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.102.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d792a36",
  null
  
)

export default component.exports